import { Component, OnDestroy, OnInit } from '@angular/core';
import { AbstractService } from '../core/abstract.service';
import { Subject, throwError } from 'rxjs';
import { MatIconModule  } from '@angular/material/icon';
import { MatButtonModule } from '@angular/material/button';
import { MatTableModule } from '@angular/material/table';
import { TimeAllocationService } from '../time-allocation/time-allocation.service';
import { Router, RouterLink } from '@angular/router';
import { catchError, finalize, takeUntil } from 'rxjs/operators';
import { TimeAllocation, TimeAllocationDetail, TimeAllocationLocation, TimeAllocationWorkedService, TimeAllocationRole } from '../shared/time-allocation.interface';
import { SharedModulesModule } from '../shared/shared-modules.module';
import { MatDialog } from '@angular/material/dialog';
import { MatSnackBar } from '@angular/material/snack-bar';
import { DeleteEntryDialogComponent } from '../dialogs/delete-entry/delete-entry.component';

@Component({
  selector: 'app-time-allocation-history',
  templateUrl: './time-allocation-history.component.html',
  styleUrls: ['./time-allocation-history.component.scss'],
  imports: [
    SharedModulesModule,
    RouterLink,
    MatTableModule, 
    MatButtonModule, 
    MatIconModule, 
  ],
})
export class TimeAllocationHistoryComponent extends AbstractService implements OnInit, OnDestroy {
  private unsubscriber: Subject<void> = new Subject<void>();
  loading = false;
  displayedColumns: string[] = ['serviceDate', 'location', 'hoursWorked', 'hoursTraveled', 'service', 'role', 'expand'];
  expandedAllocation: TimeAllocationDetail | null;
  timeAllocationHistory: TimeAllocationDetail[];
  dataSource: any[] = [];
  allocationLocations: TimeAllocationLocation[];
  allocationServices: TimeAllocationWorkedService[];
  allocationRoles: TimeAllocationRole[];
  message;

  constructor(private router: Router,
    public dialog: MatDialog,
    private timeAllocationService: TimeAllocationService,
    private snackbar: MatSnackBar) {
    super();
  }

  ngOnInit(): void {
    this.loading = true;
    this.timeAllocationService.getTimeAllocationLocations().subscribe(locations => {
      this.allocationLocations = locations;
    });
    this.timeAllocationService.getTimeAllocationServices().subscribe(services => {  
      this.allocationServices = services;
    });
    this.timeAllocationService.getTimeAllocationRoles().subscribe(roles => {
      this.allocationRoles = roles;
    });
    setTimeout(() => {
      this.timeAllocationService.getTimeAllocationHistory()
        .pipe(
          takeUntil(this.unsubscriber),
          finalize(() => this.loading = false)
        )
        .subscribe((d) => {
          console.log(d);
          this.timeAllocationHistory = d.sort((a, b) => {
            if(a.serviceDate == b.serviceDate) {
              return a.locationShortName < b.locationShortName ? -1 : 1;
            } else {
              return a.serviceDate > b.serviceDate ? -1 : 1 ;
            }
          });
          this.setupDataSource();
        });
      console.log('Time Allocation History: ', this.timeAllocationHistory);
    }, 2000);
  }

  setupDataSource() {
    this.timeAllocationHistory.forEach(allocation => {
      this.dataSource.push({
        allocationID: allocation.allocationID,
        locationID: allocation.locationID,
        locationShortName: allocation.locationShortName,
        serviceDate: allocation.serviceDate,
        hoursWorked: allocation.hoursWorked,
        hoursTraveled: allocation.hoursTraveled,
        allocationNote: allocation.allocationNote,
        allocationServiceID: allocation.allocationServiceID,
        serviceDescription: allocation.serviceDescription,
        allocationRoleID: allocation.allocationRoleID,
        roleDescription: allocation.roleDescription,
      });
    });
  }

  isExpanded(allocation: TimeAllocationDetail) {
    return this.expandedAllocation === allocation;
  }

  editAllocation(allocation: TimeAllocation): void {
    console.log('Editing Time Allocation:', allocation.allocationID);
    this.router.navigate(['time-allocation'], { state: { allocationID: allocation.allocationID } });
  }

  deleteAllocation(allocation: TimeAllocation): void {
    const dialogRef = this.dialog.open(DeleteEntryDialogComponent, {
      width: '300px',
      data: { entryType: 'Time Allocation' }
    });

    dialogRef.afterClosed().subscribe(result => {
      if (result) {
        console.log('Deleting Time Allocation:', allocation.allocationID);
        allocation.delete = true;
        this.timeAllocationService.save(allocation).pipe(
          takeUntil(this.unsubscriber),
          finalize(() => { this.loading = false; this.message = null; }),
          catchError(err => throwError(err))
        ).subscribe(result => {
          let snackbarMessage = '';
          console.log('Result: ', result);
          if (result) {
            if (JSON.stringify(result).includes('ERROR')) {
              snackbarMessage = result.replace('ERROR: ', '');
            } else {
              snackbarMessage = 'Delete Time Allocation Success';
            }
          } else {
            snackbarMessage = 'Delete Time Allocation Failure';
          }
          this.snackbar.open(snackbarMessage, 'Dismiss');
          this.router.navigate(['time-allocation']);
        });
      } 
      else {
        console.log('Delete Time Allocation Cancelled');
      }
    });
  }

  ngOnDestroy(): void {
    this.unsubscriber.next();
    this.unsubscriber.complete();
  }
}
